import api from '../../config/configApi';
import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";

// Interface do paciente
interface Patient {
  id: string;
  nome: string;
  idade: string;
  dtinicio: string;
  dtfim: string;
  frequencia: string;
  fisio: string;
  fono: string;
  psico: string;
  nutri: string;
  curativo: string;
  observacao: string;
  img?: string[];
  cep?: string;
  bairro?: string;
  regiao?: string;
  localidade?: string;
  regimeCoparticipacao?: string;
}


const Dashboard: React.FC = () => {
  const [search, setSearch] = useState("");

  const [patients, setPatients] = useState<Patient[]>([
    {
      id: "2",
      nome: "ANTONIA PEREIRA SILVA CHAVES",
      idade: "86",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "30 SESSÕES",
      fisio: "x",
      fono: "x",
      psico: "x",
      nutri: "INICIOU + 10 SESSÕES",
      curativo: "FINALIZADO",
      observacao: "ENCAMINHADO P CENTRO MÉDICO",
    },
    {
      id: "3",
      nome: "ADELINA LUNA SALES DE ARAÚJO",
      idade: "60",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "20 SESSÕES",
      fisio: "x",
      fono: "x",
      psico: "x",
      nutri: "INICIOU + 10 SESSÕES",
      curativo: "FINALIZADO",
      observacao: "",
    },
    {
      id: "4",
      nome: "JOSE MAILTON DE MELO",
      idade: "81",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "05.01.2023",
      curativo: "FINALIZADO",
      observacao: "ENCAMINHADO P CENTRO MÉDICO",
    },
    {
      id: "5",
      nome: "MARIA DO ROSÁRIO ATHAYDE NÓBREGA",
      idade: "75",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "20 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "AUTORIZADO EM 01/10/ PAUSADO EM 22",
      curativo: "FINALIZADO",
      observacao: "OBESIDADE",
    },
    {
      id: "6",
      nome: "CELIA INACIA URQUIZA MEIRA DE SA",
      idade: "88",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "6 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "AUT 6 SESSÕES EM 17.02",
      curativo: "INCLUSA NO SAD",
      observacao: "",
    },
    {
      id: "7",
      nome: "CREUZA FREIRE SOARES",
      idade: "91",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "01/03/23",
      curativo: "INCLUSA NO SAD",
      observacao: "AUT. POR DRA ANDREA",
    },
    {
      id: "8",
      nome: "AUREANITA CAVALCANTI CARVALHO",
      idade: "92",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "20 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "18/04/23",
      curativo: "26/06/23",
      observacao: "AUT. POR DRA ANDREA",
    },
    {
      id: "9",
      nome: "ODAILZA DIAS DA SILVA",
      idade: "90",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "10.05.2023",
      curativo: "FINALIZADO",
      observacao: "NOVA AVALIAÇÃO EM 04.08 – SEM INDICAÇÃO DOMICILIAR",
    },
    {
      id: "10",
      nome: "FRANCISCO JOSE DA COSTA",
      idade: "81",
      dtinicio: "01/01/2025",
      dtfim: "01/12/2025",
      frequencia: "AVALIAÇÃO",
      fisio: "",
      fono: "",
      psico: "",
      nutri: "INCLUSA NO SAD",
      curativo: "",
      observacao: "",
    },
    {
      id: "11",
      nome: "RITA SOARES LOUREIRO RODRIGUES",
      idade: "88",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "15.06.2023",
      curativo: "",
      observacao: "",
    },
    {
      id: "12",
      nome: "EUZO DA CUNHA CHAVES",
      idade: "65",
      dtinicio: "CURATIVO",
      dtfim: "01/12/2025",
      frequencia: "Curativo",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "WELL",
      curativo: "19.06.2023",
      observacao: "alta",
    },
    {
      id: "13",
      nome: "ALZENI RODRIGUES DOS SANTOS",
      idade: "80",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "21/06/23",
      curativo: "",
      observacao: "PÓS FRATURA (QUEDA)",
    },
    {
      id: "14",
      nome: "LAUREMAN VASCONCELOS FERREIRA",
      idade: "84",
      dtinicio: "01/01/2025",
      dtfim: "01/12/2025",
      frequencia: "Curativo",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "WELL",
      curativo: "26/06/23",
      observacao: "alta PÓS INTERNAÇÃO LPP SACRAL",
    },
    {
      id: "15",
      nome: "DIANA DE MEDEIROS LACERDA",
      idade: "82",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "X",
      fisio: "ANDRET",
      fono: "X",
      psico: "X",
      nutri: "20/07/23",
      curativo: "",
      observacao: "AUTORIZADO 10 SESSÕES",
    },
    {
      id: "16",
      nome: "INACIO RAMOS DE QUEIROZ",
      idade: "",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "31/12/67",
      curativo: "",
      observacao: "AUTORIZADO 10 SESSÕES",
    },
    {
      id: "17",
      nome: "IRACEMA COUTINHO GOMES",
      idade: "",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "",
      curativo: "03/10/23",
      observacao: "ALTA PARA CM",
    },
    {
      id: "18",
      nome: "HERONIDES MONTGOMERY NEVES",
      idade: "79",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "25/09/23",
      curativo: "",
      observacao: "FRATURA DE TÍBIA E FÍBULA D",
    },
    {
      id: "19",
      nome: "AILTON PARENTE DE ALENCAR",
      idade: "88",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "X",
      fono: "X",
      psico: "X",
      nutri: "02/10/23",
      curativo: "",
      observacao: "PÓS-FRATURA DE QUADRIL",
    },
    {
      id: "20",
      nome: "ELIJANETE GOMES DE LIMA",
      idade: "85",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "x",
      fono: "x",
      psico: "x",
      nutri: "09/10/23",
      curativo: "concluído",
      observacao: "",
    },
    {
      id: "21",
      nome: "TERESINHA VILAR DE MIRANDA GONÇALVES",
      idade: "87",
      dtinicio: "01/01/2025",
      dtfim: "01/12/2025",
      frequencia: "AVALIAÇÃO",
      fisio: "x",
      fono: "x",
      psico: "x",
      nutri: "FISIOTERAPIA",
      curativo: "CONCLUÍDO",
      observacao: "",
    },
    {
      id: "22",
      nome: "ITACY SEDUBAI",
      idade: "89",
      dtinicio: "01/01/2025",
      dtfim: "01/12/2025",
      frequencia: "",
      fisio: "x",
      fono: "x",
      psico: "x",
      nutri: "FISIOTERAPIA",
      curativo: "CONCLUÍDO",
      observacao: "",
    },
    {
      id: "23",
      nome: "BERNADETE DE LOURDES DE A. LOURENCO",
      idade: "70",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "x",
      fono: "x",
      psico: "x",
      nutri: "x",
      curativo: "PENDENTE",
      observacao: "exame",
    },
    {
      id: "24",
      nome: "ANTONIEL MAXIMO DA SILVA ",
      idade: "75",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "x",
      fisio: "x",
      fono: "x",
      psico: "x",
      nutri: "FINALIZADO",
      curativo: "FINALIZADO",
      observacao: "",
    },
    {
      id: "25",
      nome: "JOSE DE SOUSA LIRA",
      idade: "70",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
      frequencia: "10 SESSÕES",
      fisio: "x",
      fono: "x",
      psico: "x",
      nutri: "x",
      curativo: "FINALIZADO",
      observacao: "exame",
    },
  ]);

  const [newPatient, setNewPatient] = useState<Patient>({
    id: "",
    nome: "",
    idade: "",
    dtinicio: "",
    dtfim: "",
    frequencia: "",
    fisio: "",
    fono: "",
    psico: "",
    nutri: "",
    curativo: "",
    observacao: "",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // Clear the form only if we're adding a new patient (i.e., newPatient.id is empty)

    setNewPatient({
      id: "",
      nome: "",
      idade: "",
      dtinicio: "01/01/2025",
      dtfim: "01/12/2025",
      frequencia: "",
      fisio: "",
      fono: "",
      psico: "",
      nutri: "",
      curativo: "",
      observacao: "",
    });
  };

  // Função que lida com as mudanças nos inputs
  const handleInputChange = async (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value, type } = e.target;

    // Lida com campos de CEP para buscar o bairro automaticamente
    if (name === "cep") {
      setNewPatient((prevState) => ({
        ...prevState,
        cep: value, // Atualiza o CEP no estado
      }));

      // Quando o campo CEP é apagado, limpa os valores relacionados
      if (value.length < 8) {
        setNewPatient((prevState) => ({
          ...prevState,
          bairro: "", // Limpa o bairro
          regiao: "", // Limpa a região
        }));
        return; // Interrompe o fluxo para evitar a busca
      }

      // Apenas busca o bairro se o CEP tiver o tamanho necessário
      if (value.length === 8) {
        try {
          const response = await fetch(
            `https://viacep.com.br/ws/${value}/json/`
          );
          const data = await response.json();

          if (data && !data.erro) {
            setNewPatient((prevState) => ({
              ...prevState,
              bairro: data.bairro || "",
              localidade: data.localidade || "", // Adicione o campo que representa a região
              regiao: data.regiao || "",
            }));
          } else {
            alert("CEP inválido ou não encontrado!");
          }
        } catch (error) {
          console.error("Erro ao buscar o bairro:", error);
        }
      }
    }

    // Verifica se o campo é de tipo "radio" e atualiza o estado corretamente
    else if (type === "radio") {
      setNewPatient((prevState) => ({
        ...prevState,
        [name]: value, // Atualiza o campo correspondente (curativo ou regimeCoparticipacao)
      }));
    }

    // Verifica se o campo é uma data e formata no padrão DD/MM/YYYY
    else if (type === "date") {
      const formattedValue = formatDateToDisplay(value);
      setNewPatient((prevState) => ({
        ...prevState,
        [name]: formattedValue,
      }));
    }

    // Atualiza diretamente outros campos
    else {
      setNewPatient((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleEditPatient = (patientId: string) => {
    const patientToEdit = patients.find((patient) => patient.id === patientId);
    if (patientToEdit) {
      setNewPatient(patientToEdit);
      openModal();

      // Função de limpeza do formulário ao fechar o modal
      return () => {
        closeModal();
        setNewPatient({
          id: "",
          nome: "",
          idade: "",
          dtinicio: "01/01/2025",
          dtfim: "01/12/2025",
          frequencia: "",
          fisio: "",
          fono: "",
          psico: "",
          nutri: "",
          curativo: "",
          observacao: "",
        });
      };
    }
  };

  const [beneficiarios, setBeneficiarios] = useState<any[]>([]);

  // Buscar beneficiários ao carregar o componente
    useEffect(() => {
      const fetchBeneficiarios = async () => {
        try {
          const token = localStorage.getItem("Frontend"); // Obtém o token armazenado
    
          if (!token) {
            throw new Error("Token de autenticação não encontrado");
          }
    
          const response = await api.get("/sisclinic/pacientes", {
            headers: {
              Authorization: `Bearer ${token}`, // Adiciona o token ao cabeçalho da requisição
            },
          });
    
          setBeneficiarios(response.data);
        } catch (error) {
          console.error("Erro ao buscar beneficiários:", error);
        } 
      };
    
      fetchBeneficiarios();
    }, []);
  

  // Função para calcular a idade a partir da data de nascimento
  const calcularIdade = (dataNascimento: string) => {
    const nascimento = new Date(dataNascimento);
    const idade = new Date().getFullYear() - nascimento.getFullYear();

    const mesAtual = new Date().getMonth();
    const diaAtual = new Date().getDate();
    const mesNascimento = nascimento.getMonth();
    const diaNascimento = nascimento.getDate();

    // Se o aniversário ainda não passou, subtrai 1 da idade
    return mesAtual > mesNascimento ||
      (mesAtual === mesNascimento && diaAtual >= diaNascimento)
      ? idade
      : idade - 1;
  };

  // Função para atualizar o nome e calcular a idade
  const handleSelectChange = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const nomeSelecionado = e.target.value;
    setNewPatient((prevState) => ({
      ...prevState,
      nome: nomeSelecionado,
    }));

    // Buscar o beneficiário pelo nome selecionado
    const beneficiarioSelecionado = beneficiarios.find(
      (beneficiario) => beneficiario.nmPaciente === nomeSelecionado
    );

    if (beneficiarioSelecionado) {
      const idadeCalculada = calcularIdade(
        beneficiarioSelecionado.DT_NASCIMENTO
      );
      setNewPatient((prevState) => ({
        ...prevState,
        idade: idadeCalculada.toString(),
      }));
    }
  };

  const [expandedPatient, setExpandedPatient] = useState<string | null>(null);

  const toggleAccordion = (patientName: string) => {
    setExpandedPatient(expandedPatient === patientName ? null : patientName);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Filtrar os pacientes pela busca
  const filteredPatients = patients.filter((patient) =>
    patient.nome.toLowerCase().includes(search.toLowerCase())
  );

  // Calcular os índices de início e fim da página
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Obter pacientes para a página atual
  const currentPatients = filteredPatients.slice(startIndex, endIndex);

  // Calcular o número total de páginas
  const totalPages = Math.ceil(filteredPatients.length / itemsPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const formatDateToInput = (date: string) => {
    if (!date) return "";
    const [day, month, year] = date.split("/"); // Exemplo: 13/12/2024
    return `${year}-${month}-${day}`; // Retorna no formato YYYY-MM-DD
  };

  const formatDateToDisplay = (date: string) => {
    if (!date) return "";
    const [year, month, day] = date.split("-"); // Exemplo: 2024-12-13
    return `${day}/${month}/${year}`; // Retorna no formato DD/MM/YYYY
  };



  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Previne o comportamento padrão de recarregar a página
   
  };

  return (
    <div className="p-6 bg-gray-100">
      <div className="flex justify-center items-center">
        <motion.img
          src="https://i0.wp.com/afrafepsaude.com.br/wp-content/uploads/2021/06/logo.png?w=692&ssl=1"
          alt="Logo AFRAFEP"
          className="mb-4 w-60 h-auto"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        />
      </div>

      <section>
        <div className="flex justify-between mb-4">
          <button
            onClick={openModal}
            className="bg-blue-500 text-white hover:bg-blue-600 px-6 py-2 rounded font-semibold"
          >
            Adicionar Paciente (EXTRA SAD)
          </button>
          <Link to="/Home">
            <button className="bg-red-500 text-white px-6 py-2 rounded font-semibold hover:bg-red-600 transition">
              Voltar
            </button>
          </Link>
        </div>
        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          contentLabel="Adicionar Paciente"
          className="bg-white p-6 rounded-lg max-w-4xl mx-auto"
          overlayClassName="fixed inset-0 bg-black bg-opacity-50"
        >
          <h1 className="text-2xl font-bold mb-4">
            {" "}
            {newPatient.id
              ? "Editar Paciente"
              : "Adicionar Paciente -  EXTRA SAD"}
          </h1>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-4 overflow-y-auto max-h-[430px]">
              <div className="flex flex-col">
                <div className="">
                  <label htmlFor="nome" className="font-medium mb-1">
                    Nome
                  </label>

                  {/* Select para selecionar o nome do beneficiário */}
                  <select
                    name="nome"
                    value={newPatient.nome}
                    onChange={handleSelectChange}
                    className="border p-2 w-[405px]"
                  >
                    <option value="" disabled>
                      Selecione o beneficiário
                    </option>
                    {beneficiarios.map((beneficiario) => (
                      <option
                        key={beneficiario.nmPaciente}
                        value={beneficiario.nmPaciente}
                      >
                        {beneficiario.nmPaciente}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="flex flex-col">
                <label htmlFor="idade" className="font-medium mb-1">
                  Idade
                </label>
                <input
                  id="idade"
                  type="text"
                  name="idade"
                  placeholder="idade"
                  value={newPatient.idade}
                  onChange={(e) =>
                    setNewPatient({ ...newPatient, idade: e.target.value })
                  }
                  className="border p-2"
                  disabled
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="dtinicio" className="font-medium mb-1">
                  Data Inicio
                </label>
                <input
                  id="dtinicio"
                  type="date"
                  name="dtinicio"
                  placeholder="Data do inicio"
                  value={formatDateToInput(newPatient.dtinicio)}
                  onChange={handleInputChange}
                  className="border p-2"
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="visitaProgramada" className="font-medium mb-1">
                  Data Fim
                </label>
                <input
                  id="dtfim"
                  type="date"
                  name="dtfim"
                  placeholder="Data do fim"
                  value={formatDateToInput(newPatient.dtfim)}
                  onChange={handleInputChange}
                  className="border p-2"
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="frequencia" className="font-medium mb-1">
                  Frequencia
                </label>
                <select
                  id="frequencia"
                  name="frequencia"
                  value={newPatient.fisio}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione a(as) quantidade(s)</option>
                  <option value="Avaliacao"> Avaliacao</option>
                  <option value="Curativo"> Curativo</option>
                  <option value="1"> 1 Sessão</option>
                  <option value="2"> 2 Sessoes</option>
                  <option value="3"> 3 Sessoes</option>
                  <option value="4"> 4 Sessoes</option>
                  <option value="5"> 5 Sessoes</option>
                  <option value="6"> 6 Sessoes</option>
                  <option value="7"> 7 Sessoes</option>
                  <option value="8"> 8 Sessoes</option>
                  <option value="9"> 9 Sessoes</option>
                  <option value="10"> 10 Sessoes</option>
                  <option value="11"> 11 Sessoes</option>
                  <option value="12"> 12 Sessoes</option>
                </select>
              </div>
              <div className="flex flex-col">
                <label htmlFor="fisio" className="font-medium mb-1">
                  Fisioterapeuta
                </label>
                <select
                  id="fisio"
                  name="fisio"
                  value={newPatient.fisio}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione um(a) Fisioterapeuta</option>
                  <option value="RAYSSA">Rayssa</option>
                  <option value="TERESA">Teresa</option>
                </select>
              </div>
              <div className="flex flex-col">
                <label htmlFor="fono" className="font-medium mb-1">
                  Fonoaudiólogo
                </label>
                <select
                  id="fono"
                  name="fono"
                  value={newPatient.fono}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione um(a) Fonoaudiólogo</option>
                  <option value="KLAUSS">Klauss</option>
                </select>
              </div>
              <div className="flex flex-col">
                <label htmlFor="psico" className="font-medium mb-1">
                  Psicólogo
                </label>
                <select
                  id="psico"
                  name="psico"
                  value={newPatient.psico}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione um(a) Psicólogo(a)</option>
                  <option value="ANDRET">ANDRET</option>
                </select>
              </div>
              <div className="flex flex-col">
                <label htmlFor="nutri" className="font-medium mb-1">
                  Nutricionista
                </label>
                <select
                  id="nutri"
                  name="nutri"
                  value={newPatient.nutri}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione um(a) Nutricionista</option>
                  <option value="ROSANGELA">Rosangela</option>
                </select>
              </div>
              <div className="flex flex-col">
                <label htmlFor="curativo" className="font-medium mb-1">
                  Curativo
                </label>
                <div className="flex items-center space-x-4">
                  {/* Opção "Sim" */}
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      id="curativoSim"
                      name="curativo"
                      value="SIM"
                      checked={newPatient.curativo === "SIM"}
                      onChange={handleInputChange}
                      className="form-radio"
                    />
                    <span>Sim</span>
                  </label>

                  {/* Opção "Não" */}
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      id="curativoNao"
                      name="curativo"
                      value="NAO"
                      checked={newPatient.curativo === "NAO"}
                      onChange={handleInputChange}
                      className="form-radio"
                    />
                    <span>Não</span>
                  </label>
                </div>
              </div>
              <div className="flex flex-col">
                <label htmlFor="observacao" className="font-medium mb-1">
                  Observações
                </label>
                <textarea
                  id="observacao"
                  name="observacao"
                  placeholder="Observações adicionais"
                  value={newPatient.observacao}
                  onChange={handleInputChange}
                  className="border p-2"
                />
              </div>
            </div>

            <div className="mt-6 flex justify-end">
              <button
                /*                 onClick={handleAddPatient}
                 */ type="submit"
                className="bg-blue-500 hover:bg-blue-600 text-white p-2 rounded w-32 h-10 mt-1"
              >
                {newPatient.id ? "Atualizar" : "Adicionar"}
              </button>
              <button
                onClick={closeModal}
                type="button"
                className="bg-red-500 hover:bg-red-600 text-white p-2 rounded w-32 h-10 ml-4 mt-1"
              >
                Cancelar
              </button>
            </div>
          </form>
        </Modal>
        {/* Campo de busca */}
        <br /> <label>Buscar pelo nome:</label>
        <input
          type="text"
          placeholder="Buscar paciente..."
          className="border p-2 w-full mb-4"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        {/* Tabela de Pacientes */}
        <div className="overflow-x-auto bg-white shadow-md rounded p-4">
          <table className="w-full table-auto border-collapse">
            <thead>
              <tr>
                <th className="px-4 py-2 border-b text-gray-700">Nome</th>
                <th className="px-4 py-2 border-b text-gray-700">Idade</th>

                <th className="px-4 py-2 border-b text-gray-700">
                  Data inicio
                </th>
                <th className="px-4 py-2 border-b text-gray-700">Data Final</th>
                <th className="px-4 py-2 border-b text-gray-700">Sessões </th>
                <th className="px-4 py-2 border-b text-left">Ações</th>
              </tr>
            </thead>
            <tbody>
              {currentPatients.map((patient, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td
                      className="px-4 py-2 cursor-pointer border-l-4"
                      onClick={() => toggleAccordion(patient.nome)}
                    >
                      {patient.nome}
                    </td>
                    <td className="px-4 py-2 border-b text-gray-700">
                      {patient.idade}
                    </td>
                    <td className="px-4 py-2 border-b text-gray-700">
                      {patient.dtinicio}
                    </td>
                    <td className="px-4 py-2 border-b text-gray-700">
                      {patient.dtfim}
                    </td>
                    <td className="px-4 py-2 border-b text-gray-700">
                      {patient.frequencia}
                    </td>
                    <td className="px-4 py-2 border-b">
                      <button
                        onClick={() => handleEditPatient(patient.id)}
                        className="bg-yellow-500 text-white p-1 rounded mr-2"
                      >
                        Editar
                      </button>
                      <button
                        onClick={() => {
                          const updatedPatients = patients.filter(
                            (p) => p.id !== patient.id
                          );
                          setPatients(updatedPatients);
                        }}
                        className="bg-red-500 text-white p-1 rounded"
                      >
                        Remover
                      </button>
                    </td>
                  </tr>

                  {/* Accordion - Informações adicionais */}
                  {expandedPatient === patient.nome && (
                    <tr>
                      <td
                        colSpan={7}
                        className="px-4 py-2 border-b bg-gray-100"
                      >
                        <div className="flex flex-wrap">
                          {patient.fisio && (
                            <div className="w-full px-2">
                              <p>
                                <strong>FISIO:</strong> {patient.fisio}
                              </p>
                            </div>
                          )}
                          {patient.fono && (
                            <div className="w-full px-2">
                              <p>
                                <strong>FONO:</strong> {patient.fono}
                              </p>
                            </div>
                          )}
                          {patient.psico && (
                            <div className="w-full px-2">
                              <p>
                                <strong>PSICO:</strong> {patient.psico}
                              </p>
                            </div>
                          )}
                          {patient.nutri && (
                            <div className="w-full px-2">
                              <p>
                                <strong>NUTRI:</strong> {patient.nutri}
                              </p>
                            </div>
                          )}
                          {patient.curativo && (
                            <div className="w-full px-2">
                              <p>
                                <strong>Curativo:</strong> {patient.curativo}
                              </p>
                            </div>
                          )}
                          {patient.observacao && (
                            <div className="w-full px-2">
                              <p>
                                <strong>OBSERVAÇÃO:</strong>{" "}
                                {patient.observacao}
                              </p>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
        {/* Paginação */}
        <div className="flex justify-between items-center mt-4">
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            className={`p-2 ${
              currentPage === 1
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-500 text-white"
            } rounded`}
          >
            Anterior
          </button>
          <p>
            Página {currentPage} de {totalPages}
          </p>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className={`p-2 ${
              currentPage === totalPages
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-500 text-white"
            } rounded`}
          >
            Próxima
          </button>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
